const useProfile = { USE_PROFILES: { html: false, svg: false, mathMl: false }};

export default useProfile;